<template>
  <v-hover v-slot:default="{ hover }">
    <!-- <v-form ref="form" v-model="formIsValid"> -->
    <!-- :rules="rules" :hide-details="formIsValid" -->
    <v-textarea
      v-if="textarea"
      v-bind="$attrs"
      v-on="$listeners"
      :value="value"
      solo
      rows="1"
      auto-grow
      style="word-break: normal !important;"
      :flat="(!editing && !hover) || ('readonly' in $attrs && $attrs['readonly'] === true)"
      @mousedown="onEditingStart"
      @keydown.enter.prevent="handleEnter"
      @focus="onEditingStart"
      @blur="onEditingDone"
    >
      <!-- :class="{ 'editing-style': editing }" -->
      <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name" />
      </template>
    </v-textarea>

    <v-text-field
      v-else
      v-bind="$attrs"
      v-on="$listeners"
      :value="value"
      solo
      style="word-break: normal !important;"
      :flat="(!editing && !hover) || ('readonly' in $attrs && $attrs['readonly'] === true)"
      @mousedown="onEditingStart"
      @keydown.enter.prevent="handleEnter"
      @focus="onEditingStart"
      @blur="onEditingDone"
    >
      <!-- :class="{ 'editing-style': editing }" -->
      <template v-for="(index, name) in $slots" v-slot:[name]>
        <slot :name="name" />
      </template>
    </v-text-field>

    <!-- </v-form> -->
    <!-- Posso settare questa proprietà per cambiare il colore del background quando ci passo sopra
      :background-color="showEditable? '#eeeeee' : ''"
    in tal caso dovrei mettere il flat solo se clicco
      flat="!editing" -->
  </v-hover>
</template>

<script>
import Logger from '@/lib/Logger'

export default {
  // inheritAttrs: false,

  props: {
    value: {
      type: String,
      required: true,
    },
    textarea: {
      type: Boolean,
      required: false,
      default: false,
    },
    /* rules: { // FIXME: mi piacerebbe implementarlo internamente, ma ora non reisco perché devo risolvere il problema dell'ereditarietà degli attributi
      type: Array,
      required: false,
      default: () => [],
    },
    class: {
      type: String,
      required: false,
      default: '',
    }, */
  },

  data: () => ({
    editing: false,
    // formIsValid: true,
    textBackup: '',
  }),

  computed: {},

  methods: {
    //!FIXME da trasferire in una libreria comune
    isFocusable(el) {
      if (['BUTTON', 'INPUT', 'TEXTAREA'].includes(el.nodeName)) {
        return true
      }
      return false
      // return ('autofocus' in el)
    },
    findNextFocusableElement(el) {
      // Logger.debug('findNextElement', el)
      const x = el.nextSibling
      if (!x) {
        if (el.parentNode) {
          return this.findNextFocusableElement(el.parentNode)
        } else {
          return null
        }
      } else {
        const y = this.searchFocusableChild(x)
        if (y) {
          return y
        } else {
          return this.findNextFocusableElement(x)
        }
      }
    },
    searchFocusableChild(el) {
      // Logger.debug('searchFocusableChild', el)
      if (this.isFocusable(el)) {
        // Logger.debug('el')
        // console.dir(el)
        return el
      }
      let found = null
      el.childNodes.forEach(child => {
        if (!found) {
          if (this.isFocusable(child)) {
            // Logger.debug('child', child)
            found = child
          } else {
            found = this.searchFocusableChild(child)
          }
        }
      })
      return found
    },
    handleEnter(e) {
      Logger.debug('SlTextField handleEnter()', e.target)
      const x = this.findNextFocusableElement(e.target)
      if (x) {
        Logger.debug('Trovato next focusable:', x)
        x.focus() // ci penserà il blur a scatenare onEditingDone()
      } else {
        this.onEditingDone()
      }
    },

    onEditingStart() {
      this.editing = true
      this.textBackup = this.value
      this.$emit('edit')
    },
    onEditingDone() {
      this.editing = false
      this.$emit('edit-done')
      if (this.value !== this.textBackup) {
        //if (this.formIsValid) {
        this.$emit('update')
        this.textBackup = this.value
        // } else {
        //   this.toastSet({
        //     message: 'Error in text validation, restoring previous text',
        //     color: 'error',
        //   })
        //   this.value = this.textBackup
        // }
      }
    },
  },
}
</script>

<style scoped>
/* .slinput  {
  background: grey !important;
} */
</style>
